import React from 'react'
import OurMission from '../../components/about/ourMission/OurMission'
import Vision from '../../components/about/vision/Vision'
import Globeimg from '../../components/about/globeImg/Globeimg'
import Leadership from '../../components/about/leadership/Leadership'
import Comejoin from '../../components/about/comeJoin/Comejoin'
import Achievements from '../../components/about/achievements/Achievements'

function About() {
  return (
    <>
      <OurMission />
      <Globeimg />
      <Vision />
      <Leadership />
      {/* <Achievements /> */}
      <Comejoin />
    </>
  )
}

export default About
